import { render, staticRenderFns } from "./PriceSwitcher.vue?vue&type=template&id=4b1a15b2&scoped=true"
import script from "./PriceSwitcher.vue?vue&type=script&lang=js"
export * from "./PriceSwitcher.vue?vue&type=script&lang=js"
import style0 from "./PriceSwitcher.vue?vue&type=style&index=0&id=4b1a15b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1a15b2",
  null
  
)

export default component.exports